import TestInfo from "./TestInfo";

export default TestInfo;